import {Component} from '@angular/core';

@Component({
  selector: 'evicare-privacy-dialog',
  templateUrl: './privacy-dialog.component.html',
  styleUrls: ['./privacy-dialog.component.scss'],
})
export class PrivacyDialogComponent {
}
